export default __webpack_public_path__ + "static/media/A3.2342a78d.mp3";